import React, { ReactElement } from 'react';
import { Form, FormItemProps, Select, SelectProps } from 'antd';

import { LeashContent } from 'leash/utilities/localStorage/leashContentStorage';
import { TransporterCompany } from 'types';

const { Option } = Select;

type Props = FormItemProps & SelectProps<string>;

export function FieldTransporterCompany(props: Props): ReactElement | null {
  if (!LeashContent?.transporterCompanies) return null;
  const { label, placeholder, name, onChange, required } = props;

  return (
    <Form.Item
      name={name ?? 'transporterCompany'}
      label={label ?? 'Transporter company'}
      rules={[{ required, message: 'Select a transporter company' }]}
    >
      <Select
        data-testid="transporter-company"
        showSearch
        placeholder={placeholder ?? 'Select an option'}
        optionFilterProp="children"
        filterOption={(input, option) => {
          return option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
        }}
        onChange={onChange}
      >
        {LeashContent.transporterCompanies.map((t: TransporterCompany) => (
          <Option value={t.id} key={t.id}>
            {t.name}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}
